module.exports = __webpack_public_path__ + "img/cszl-2.7337a808.png";